<tiime-dialog (cancel)="cancel()">
  <span mat-dialog-title data-cy="create-user-dialog-title">Ajouter une personne physique</span>
  <mat-dialog-content class="dialog-content" mat-dialog-content data-cy="create-user-dialog">
    <div class="user-form" tiimeForm>
      <div tiimeFormColumn>
        <app-create-user-form
          [formGroup]="userForm"
          [excludedAutocompleteUsers]="overlayData().excludedAutocompleteUsers"
        ></app-create-user-form>
        <div class="user-form-actions" tiimeFormRow>
          <button
            type="button"
            tiime-button
            color="accent"
            strocked
            large
            [disabled]="userForm.disabled"
            (click)="cancel()"
            data-cy="create-user-dialog-cancel-btn"
          >
            Annuler
          </button>
          <span
            tiimeTooltip="L'email fourni est déjà utilisé pour un autre contact."
            [tooltipDisabled]="!(existingUsers().length > 0 && emailAlreadyUsed())"
          >
            <button
              type="button"
              tiime-button
              #submitButton
              color="accent"
              large
              raised
              [disabled]="userForm.disabled || (existingUsers().length > 0 && emailAlreadyUsed())"
              (click)="submitUserForm()"
              data-cy="create-user-dialog-save-btn"
            >
              Ajouter
            </button>
          </span>
        </div>
      </div>
      @if (existingUsers().length) {
        <div class="existing-users__container">
          <tiime-alert warn>
            {{ existingUsersMessage() }}
          </tiime-alert>
          <div class="existing-users__container__list">
            @for (user of existingUsers(); track user.id) {
              <div data-cy="create-user-dialog-existing-user" class="selectable-user">
                <div class="selectable-user-informations">
                  <span>
                    <mat-icon inline="true" fontSet="fontastic" fontIcon="icon-ic-clients2"></mat-icon>
                    {{ user.firstName }} {{ user.lastName }}
                    <br />
                  </span>
                  @if (user.email) {
                    <span>
                      <mat-icon inline="true" fontSet="fontastic" fontIcon="icon-ic-email"></mat-icon>
                      {{ user.email }}
                      <br />
                    </span>
                  }
                  @if (user.phone) {
                    <span>
                      <mat-icon inline="true" fontSet="fontastic" fontIcon="icon-ic-phone"></mat-icon>
                      {{ user.phone | phone }}
                      <br />
                    </span>
                  }
                </div>
                <button
                  data-cy="create-user-dialog-select-existing-user-btn"
                  tiime-button
                  color="accent"
                  raised
                  type="button"
                  (click)="selectExistingUser(user)"
                >
                  Sélectionner
                </button>
              </div>
            }
          </div>
        </div>
      }
    </div>
  </mat-dialog-content>
</tiime-dialog>
